import PropTypes from 'prop-types'

import React from 'react'
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'

import './Popup.scss'

function Popup(props) {
  const {
    show,
    onClose,
    modalClass,
    iconUrl,
    title,
    children,
    backdrop,
    useWhiteBackground,
    size,
    align,
    showActions,
    cancelLabel,
    okLabel,
    onOkClick,
    isOnCloseSpecial,
  } = props

  const popupClass = `popup ${modalClass} ${align === 'center' && 'text-center'} ${
    useWhiteBackground && 'modal-dialog-white'
  } ${!!iconUrl && 'modal-dialog-with-icon'}`

  return (
    <Modal
      centered
      scrollable
      isOpen={show}
      toggle={onClose}
      backdrop={backdrop}
      keyboard={false}
      size={size}
      className={popupClass}
    >
      {iconUrl && (
        <div className="modal-icon">
          <img src={iconUrl} alt={title} />
        </div>
      )}

      {title ? (
        !isOnCloseSpecial ? (
          <ModalHeader>{title}</ModalHeader>
        ) : (
          <ModalHeader toggle={onClose} className="style-special">
            {title}
          </ModalHeader>
        )
      ) : null}
      <ModalBody>{children}</ModalBody>

      {showActions && (
        <ModalFooter>
          <Row>
            <Col className="btn-left">
              <Button block color="light" onClick={onClose} className="btn--cancel">
                {cancelLabel}
              </Button>
            </Col>

            <Col className="btn-right">
              <Button block color="light" onClick={onOkClick} className="btn--ok">
                {okLabel}
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      )}
    </Modal>
  )
}

Popup.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,

  iconUrl: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  children: PropTypes.any,

  useWhiteBackground: PropTypes.bool,
  backdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  align: PropTypes.oneOf(['left', 'center']),

  showActions: PropTypes.bool,
  cancelLabel: PropTypes.string,
  okLabel: PropTypes.string,
  onOkClick: PropTypes.func,

  modalClass: PropTypes.string,
}

Popup.defaultProps = {
  show: false,
  onClose: PropTypes.func,

  iconUrl: '',
  title: '',
  children: null,

  useWhiteBackground: false,
  backdrop: true,
  size: 'sm',
  align: 'left',

  showActions: true,
  cancelLabel: 'Cancel',
  okLabel: 'Ok',
  onOkClick: null,

  modalClass: '',
}

export default Popup
